import {KeycloakContext} from "./keycloak";
import {useContext} from "react";

export const useKeycloak = () => {
	const context = useContext(KeycloakContext);

	return context;
};
